// House Banister (1980) male. Must match backend/recovery.py:
// TRIMP/min = HRR × 0.64 × exp(1.92 × HRR)
// HRR: easy = EASY_HRR 0.55; moderate = mid of intensity_zone moderate
// [0.60, 0.70); hard = KIND_HRR.workout 0.78.

export const BANISTER_A = 0.64;
export const BANISTER_B = 1.92;
export const TRIMP_RATE_HRR = { easy: 0.55, moderate: 0.65, hard: 0.78 };

export function trimpPerMinute(hrr) {
  const h = Math.min(Math.max(Number(hrr), 0), 1);
  if (!Number.isFinite(h)) return 0;
  return h * BANISTER_A * Math.exp(BANISTER_B * h);
}

export function trimpRateLegend() {
  const out = {};
  for (const [name, hrr] of Object.entries(TRIMP_RATE_HRR)) {
    out[name] = Math.round(trimpPerMinute(hrr) * 100) / 100;
  }
  return out;
}

export function runTrimpPerMinute(trimp, minutes) {
  if (!Number.isFinite(trimp) || !Number.isFinite(minutes) || minutes <= 0) return null;
  return Math.round((trimp / minutes) * 100) / 100;
}
